import { Button, Icon, message, Popconfirm, Tooltip } from "antd";
import ResultMessage from "components/CourseComponents/ResultMessage";
import moment from "moment";
import React from "react";
import { FileItem, removeExamInfoExtraFile } from "service/exam";
import { errorMessage } from "service/service";
import style from "./index.module.scss";

interface AccessoryListItem extends FileItem {
    updateExamInfo?: () => void; //更新监考详情
}

export default function AccessoryList(props: AccessoryListItem) {
    const { id, fileName, teacherName, time, updateExamInfo } = props;
    const url = decodeURIComponent(fileName);

    const name = url.split("=").pop();

    //下载附件
    const handleDownload = () => {
        window.open(fileName);
    };

    const handleDelete = async () => {
        try {
            await removeExamInfoExtraFile(id);
            message.success("删除成功");
            updateExamInfo && updateExamInfo();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    };

    return (
        <div className={style.root}>
            <div className={style.fileName} onClick={handleDownload}>
                <Icon type="file-zip" theme="filled" />
                <Tooltip title={name} placement="topLeft">
                    {name}
                </Tooltip>
            </div>
            <div className={style.info}>
                <span className={style.teacherName}>
                    {teacherName}老师&nbsp;&nbsp;
                </span>
                <span className={style.time}>
                    {moment(time).format("YYYY-MM-DD HH:mm:ss")}&nbsp;&nbsp;上传
                </span>
            </div>

            <Popconfirm
                placement="top"
                title={
                    <div className={style.pop}>
                        <div>删除补传附件?</div>
                        <div className={style.popSubTitle}>
                            删除后无法恢复，确定删除？
                        </div>
                    </div>
                }
                okText="确定"
                cancelText="取消"
                onConfirm={handleDelete}
                overlayStyle={{ zIndex: 1060 }}>
                <Button type="link" className={style.opacity}>
                    <Icon type="delete" />
                </Button>
            </Popconfirm>
        </div>
    );
}
